/* eslint-disable indent */
import { Link } from '@solidjs/router';
import { Match, Show, Switch, useContext } from 'solid-js';
import { AppContext } from '../../../app-context-provider/app-context-provider';
import { Grid } from '../../../grid-system/grid/grid';
import theme from '../../../style/theme';
import { ErrorCatcher } from '../../../tools/error-catcher';
import { NewAtosLogoDeepBlue } from '../../icons-library/new-atos-logo-deep-blue';

export const HeaderCampaignContainer = () => {
    const { viewport } = useContext(AppContext);

    let headerRef: any;

    return (
        <ErrorCatcher componentName="Header">
            <header class="[container-type:inline-size] h-[10rem] static z-[3] top-0 left-0 right-0 overflow-hidden max-tablet:h-[6.43rem] print:hidden">

                <Grid templateShorthand={[ 12 ]} customCss={'height: inherit;'} isLayoutGrid={true}>
                    <div class="flex items-center relative h-[inherit] z-[2] pt-[0.36rem]">
                        <div>
                            <Link href="/">
                                <Switch>
                                    <Match when={viewport.width >= theme.breakpoints.TABLET}>
                                        <div class="w-auto">
                                            <Show when={false} fallback={<NewAtosLogoDeepBlue width={11} />}>
                                                <NewAtosLogoDeepBlue width={7.5} />
                                            </Show>
                                        </div>
                                    </Match>
                                    <Match when={viewport.width <= theme.breakpoints.TABLET}>
                                        <div class="w-auto">
                                            <NewAtosLogoDeepBlue width={9.36} />
                                        </div>
                                    </Match>
                                </Switch>
                            </Link>
                        </div>
                    </div>
                </Grid>

            </header>
            <div ref={headerRef} />
        </ErrorCatcher>
    );
};
